import { FuseNavigation } from 'src/@fuse/types';

export const navigation: FuseNavigation[] = [
  {
    id: 'bussiness',
    title: 'BUSSINESS',
    type: 'group',
    translate: '',
    icon: '',
    url: '',
    children: [
      {
        id: 'facturacion',
        title: 'Facturación',
        type: 'item',
        icon: 'library_books',
        url: '/facturacion',
        translate: '',
      },
      {
        id: 'comprobantes',
        title: 'Comprobantes',
        icon: 'library_books',
        type: 'collapsable',
        translate: '',
        url: '',
        children: [
          {
            id: 'emision',
            title: 'Emision',
            type: 'item',
            icon: 'library_books',
            url: '#',
            translate: '',
          },
          {
            id: 'registro',
            title: 'Registro',
            type: 'item',
            icon: 'library_books',
            url: '#',
            translate: '',
          },
        ],
      },
      {
        id: 'entidad',
        title: 'Entidad',
        type: 'item',
        icon: 'library_books',
        url: '#',
        translate: '',
      },
      {
        id: 'inventario',
        title: 'Inventario',
        icon: 'library_books',
        type: 'collapsable',
        translate: '',
        url: '',
        children: [
          {
            id: 'materia-prima',
            title: 'Materia Prima',
            type: 'item',
            icon: 'library_books',
            url: '/inventario/materia-prima/existencias',
            translate: '',
          },
          {
            id: 'materia-auxiliar',
            title: 'Materia Auxiliar',
            type: 'item',
            icon: 'library_books',
            url: '#',
            translate: '',
          },
          {
            id: 'producto-proceso',
            title: 'Producto Proceso',
            type: 'item',
            icon: 'library_books',
            url: '#',
            translate: '',
          },
          {
            id: 'producto-terminado',
            title: 'Producto Terminado',
            type: 'item',
            icon: 'library_books',
            url: '#',
            translate: '',
          },
        ],
      },
      {
        id: 'despacho',
        title: 'Despacho',
        type: 'item',
        icon: 'library_books',
        url: '#',
        translate: '',
      },
      {
        id: 'impuestos',
        title: 'Impuestos',
        icon: 'library_books',
        type: 'collapsable',
        translate: '',
        url: '',
        children: [
          {
            id: 'senae',
            title: 'Senae',
            type: 'item',
            icon: 'library_books',
            url: '#',
            translate: '',
          },
          {
            id: 'sri',
            title: 'sri',
            type: 'item',
            icon: 'library_books',
            url: '#',
            translate: '',
          },
          {
            id: 'seccionales',
            title: 'Seccionales',
            type: 'item',
            icon: 'library_books',
            url: '#',
            translate: '',
          },
        ],
      },
      {
        id: 'contabilidad',
        title: 'Contabilidad',
        type: 'item',
        icon: 'library_books',
        url: '#',
        translate: '',
      },
      {
        id: 'repositorio',
        title: 'Repositorio',
        icon: 'library_books',
        type: 'collapsable',
        url: '',
        translate: '',
        children: [
          {
            id: 'emision',
            title: 'Emision',
            type: 'item',
            icon: 'library_books',
            url: '#',
            translate: '',
          },
          {
            id: 'registro',
            title: 'Resgistro',
            type: 'item',
            icon: 'library_books',
            url: '#',
            translate: '',
          },
        ],
      },
      {
        id: 'perfil-tributario',
        title: 'Perfil Tributario',
        translate: 'NAV.PERFIL_FACTURACION.TITLE',
        type: 'item',
        icon: 'library_books',
        url: '/parametros',
        badge: {
          title: '25',
          translate: 'NAV.SAMPLE.BADGE',
          bg: '#F44336',
          fg: '#FFFFFF',
        },
      },
    ],
  },
  {
    id: 'applications',
    title: 'APLICACIONES',
    type: 'group',
    icon: '',
    url: '',
    translate: '',
    children: [
      {
        id: 'dashboard',
        title: 'Dashboard',
        // translate: 'NAV.DASHBOARD.TITLE',
        type: 'item',
        icon: 'home',
        url: '/dashboard',
        translate: '',
      },
      {
        id: 'contactos',
        title: 'Contactos',
        type: 'item',
        icon: 'home',
        url: '/list-contactos',
        translate: '',
      },
      {
        id: 'agenda',
        title: 'Agenda',
        type: 'item',
        icon: 'home',
        url: '#',
        translate: '',
      },
      {
        id: 'chat',
        title: 'Chat',
        type: 'item',
        icon: 'home',
        url: '#',
        translate: '',
      },
      {
        id: 'curriculum',
        title: 'Curricullum',
        type: 'item',
        icon: 'home',
        url: '#',
        translate: '',
      },
      {
        id: 'email',
        title: 'Email',
        type: 'item',
        icon: 'home',
        url: '#',
        translate: '',
      },
      {
        id: 'archivos',
        title: 'Archivos',
        type: 'item',
        icon: 'home',
        url: '#',
        translate: '',
      },
    ],
  },
];
